import { RecruiterDTO, RecruiterSTO } from "../../../models/recruiting/recruiters";
import { BaseApiService } from "../../base/base-api.service";

export class RecruitersApiService extends BaseApiService<RecruiterDTO, RecruiterSTO> {
  constructor() {
    super({
      servicePath: "/Recruiters",
      loadItemsPath: "/GetRecruiters",
      saveItemsPath: "/SaveRecruiters",
    });
  }
}
